<label>{{item?.label||'select_a_field'| translation}}</label>

<nb-select
  [placeholder]="'Field'| translation"
  [fullWidth]="true"
  [(ngModel)]="selectedKey"
  (ngModelChange)="updateValue()"
  
>
  <nb-option *ngFor="let key of options" [value]="key.name">{{
    key.name
  }}</nb-option>
</nb-select>